import React from 'react'

function Blog() {
  return (
  <main id="primary" className="site-main">
      <div className="space-for-header"></div>
      {/* start: Breadcrumb Section */}
      <section className="tj-page-header section-gap-x" data-bg-image="assets/images/bg/pheader-bg.webp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tj-page-header-content text-center">
                <h1 className="tj-page-title">Read Blog</h1>
                <div className="tj-page-link">
                  <span><i className="tji-home"></i></span>
                  <span>
                    <a href="/">Home</a>
                  </span>
                  <span><i className="tji-arrow-right"></i></span>
                  <span>
                    <span>Blog</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-header-overlay" data-bg-image="assets/images/shape/pheader-overlay.png"></div>
      </section>
      {/* end: Breadcrumb Section */}

      {/* start: Blog Section */}
      <section className="tj-blog-section section-gap slidebar-stickiy-container">
        <div className="container">
          <div className="row row-gap-5">
            <div className="col-lg-8">
              <div className="blog-post-wrapper">
                <article className="blog-item wow fadeInUp" data-wow-delay=".1s">
                  <div className="blog-thumb">
                    <a href="#"><img src="assets/images/blog/blog-1.webp" alt="" /></a>
                    <div className="blog-date">
                      <span className="date">28</span>
                      <span className="month">Feb</span>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <span className="categories"><a href="#">Business</a></span>
                      <span>By <a href="#">Ellinien Loma</a></span>
                    </div>
                    <h3 className="title"><a href="#">Unlocking Business Potential: Innovative Solutions for Unmatched Success</a></h3>
                    <p className="desc">In today's fast-paced business environment, the key to staying ahead of the competition lies in embracing innovation. At [Company Name], we specialize in unlocking your business's full potential by providing tailored, forward-thinking solutions that drive growth, efficiency, and lasting success.</p>
                    <a className="text-btn" href="#">
                      <span className="btn-text"><span>Read More</span></span>
                      <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                    </a>
                  </div>
                </article>
                <article className="blog-item wow fadeInUp" data-wow-delay=".3s">
                  <div className="blog-thumb">
                    <a href="#"><img src="assets/images/blog/blog-2.webp" alt="" /></a>
                    <div className="blog-date">
                      <span className="date">28</span>
                      <span className="month">Feb</span>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <span className="categories"><a href="#">Business</a></span>
                      <span>By <a href="#">Ellinien Loma</a></span>
                    </div>
                    <h3 className="title"><a href="#">Harnessing Digital Transformation: A Roadmap to Future-Proof Your Business</a></h3>
                    <p className="desc">In the ever-evolving digital landscape, staying ahead of the curve is essential for business success. Harnessing Digital Transformation is not just about adopting new technologies but about rethinking how your business operates, delivers value, and connects with customers.</p>
                    <a className="text-btn" href="#">
                      <span className="btn-text"><span>Read More</span></span>
                      <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                    </a>
                  </div>
                </article>
                <article className="blog-item wow fadeInUp" data-wow-delay=".5s">
                  <div className="blog-thumb">
                    <a href="#"><img src="assets/images/blog/blog-3.webp" alt="" /></a>
                    <div className="blog-date">
                      <span className="date">28</span>
                      <span className="month">Feb</span>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <span className="categories"><a href="#">Business</a></span>
                      <span>By <a href="#">Ellinien Loma</a></span>
                    </div>
                    <h3 className="title"><a href="#">Leading Through Change: Proven Lessons for Effective Change Management in Business</a></h3>
                    <p className="desc">Change is inevitable, and in today's fast-paced business landscape, the ability to manage and lead through change is crucial to long-term success. Effective change management empowers organizations to adapt, innovate, and thrive despite leading through change proven challenges.</p>
                    <a className="text-btn" href="#">
                      <span className="btn-text"><span>Read More</span></span>
                      <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                    </a>
                  </div>
                </article>
                <div className="tj-pagination d-flex">
                  <ul>
                    <li>
                      <span aria-current="page" className="page-numbers current">1</span>
                    </li>
                    <li>
                      <a className="page-numbers" href="#">2</a>
                    </li>
                    <li>
                      <a className="page-numbers" href="#">3</a>
                    </li>
                    <li>
                      <a className="next page-numbers" href="#"><i className="tji-arrow-right-long"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="tj-main-sidebar slidebar-stickiy">
                <div className="tj-sidebar-widget widget-search wow fadeInUp" data-wow-delay=".1s">
                  <h4 className="widget-title">Search here</h4>
                  <div className="search-box">
                    <div>
                      <input type="search" name="search" id="searchTwo" placeholder="Search here" />
                      <button type="button" value="search">
                        <i className="tji-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="tj-sidebar-widget tj-recent-posts wow fadeInUp" data-wow-delay=".3s">
                  <h4 className="widget-title">Related post</h4>
                  <ul>
                    <li>
                      <div className="post-thumb">
                        <a href="#"> <img src="assets/images/blog/post-1.webp" alt="Blog" /></a>
                      </div>
                      <div className="post-content">
                        <h6 className="post-title">
                          <a href="#">How to Stay Ahead of the Business Curve</a>
                        </h6>
                        <div className="blog-meta">
                          <ul>
                            <li>04 SEP 2025</li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="post-thumb">
                        <a href="#"> <img src="assets/images/blog/post-2.webp" alt="Blog" /></a>
                      </div>
                      <div className="post-content">
                        <h6 className="post-title">
                          <a href="#">How Digital Tools Shaping the Workforce</a>
                        </h6>
                        <div className="blog-meta">
                          <ul>
                            <li>02 JAN 2025</li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="post-thumb">
                        <a href="#"> <img src="assets/images/blog/post-3.webp" alt="Blog" /></a>
                      </div>
                      <div className="post-content">
                        <h6 className="post-title">
                          <a href="#">How to Sustainability into your Strategy</a>
                        </h6>
                        <div className="blog-meta">
                          <ul>
                            <li>24 FEB 2025</li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="tj-sidebar-widget widget-categories wow fadeInUp" data-wow-delay=".5s">
                  <h4 className="widget-title">Categories</h4>
                  <ul>
                    <li><a href="#">Innovation<span className="number">(03)</span></a></li>
                    <li><a href="#">Leadership<span className="number">(02)</span></a></li>
                    <li><a href="#">Technology<span className="number">(03)</span></a></li>
                    <li><a href="#">Marketing<span className="number">(06)</span></a></li>
                    <li><a href="#">Management<span className="number">(04)</span></a></li>
                  </ul>
                </div>
                <div className="tj-sidebar-widget widget-tag-cloud wow fadeInUp" data-wow-delay=".7s">
                  <h4 className="widget-title">Tags</h4>
                  <nav>
                    <div className="tagcloud">
                      <a href="#">Growth</a>
                      <a href="#">Success</a>
                      <a href="#">Innovate</a>
                      <a href="#">Lead</a>
                      <a href="#">Impact</a>
                      <a href="#">Focus</a>
                      <a href="#">Tech</a>
                      <a href="#">Optimize</a>
                      <a href="#">Results</a>
                      <a href="#">Drive</a>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end: Blog Section */}
    </main>
  );
}

export default Blog
